import { useTranslation } from 'react-i18next';

interface VoiceDisplayProps {
  isEnabled: boolean;
  isVoiceDetected: boolean;
  className?: string;
}

export const VoiceDisplay = ({
  isEnabled,
  isVoiceDetected,
  className = '',
}: VoiceDisplayProps) => {
  const { t } = useTranslation('interview');

  return (
    <div className={`bg-white rounded-lg shadow-lg overflow-hidden ${className}`}>
      <div className="bg-gradient-1 py-1 px-2">
        <h2 className="text-dark-invirtus text-xs font-bold truncate font-heading">{t('live.feed.voice')}</h2>
      </div>
      <div className="flex items-center justify-center relative h-full w-full py-4">
        {isEnabled ? (
          <svg width="160" height="80" viewBox="0 0 80 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="max-w-full max-h-full">
            <g>
              <rect x="10" y={isVoiceDetected ? 10 : 14} width="6" height={isVoiceDetected ? 20 : 4} rx="3" fill={isVoiceDetected ? '#22c55e' : '#64748b'}>
                {isVoiceDetected && <animate attributeName="y" values="10;18;10" dur="0.7s" repeatCount="indefinite" />}
                {isVoiceDetected && <animate attributeName="height" values="20;4;20" dur="0.7s" repeatCount="indefinite" />}
              </rect>
              <rect x="24" y={isVoiceDetected ? 6 : 14} width="6" height={isVoiceDetected ? 28 : 4} rx="3" fill={isVoiceDetected ? '#22c55e' : '#64748b'}>
                {isVoiceDetected && <animate attributeName="y" values="6;18;6" dur="0.6s" repeatCount="indefinite" />}
                {isVoiceDetected && <animate attributeName="height" values="28;4;28" dur="0.6s" repeatCount="indefinite" />}
              </rect>
              <rect x="38" y={isVoiceDetected ? 2 : 14} width="6" height={isVoiceDetected ? 36 : 4} rx="3" fill={isVoiceDetected ? '#22c55e' : '#64748b'}>
                {isVoiceDetected && <animate attributeName="y" values="2;18;2" dur="0.5s" repeatCount="indefinite" />}
                {isVoiceDetected && <animate attributeName="height" values="36;4;36" dur="0.5s" repeatCount="indefinite" />}
              </rect>
              <rect x="52" y={isVoiceDetected ? 6 : 14} width="6" height={isVoiceDetected ? 28 : 4} rx="3" fill={isVoiceDetected ? '#22c55e' : '#64748b'}>
                {isVoiceDetected && <animate attributeName="y" values="6;18;6" dur="0.6s" repeatCount="indefinite" />}
                {isVoiceDetected && <animate attributeName="height" values="28;4;28" dur="0.6s" repeatCount="indefinite" />}
              </rect>
              <rect x="66" y={isVoiceDetected ? 10 : 14} width="6" height={isVoiceDetected ? 20 : 4} rx="3" fill={isVoiceDetected ? '#22c55e' : '#64748b'}>
                {isVoiceDetected && <animate attributeName="y" values="10;18;10" dur="0.7s" repeatCount="indefinite" />}
                {isVoiceDetected && <animate attributeName="height" values="20;4;20" dur="0.7s" repeatCount="indefinite" />}
              </rect>
            </g>
          </svg>
        ) : (
          <div className="text-gray-400 text-xs py-2 font-body">{t('live.feed.voice_not_enabled')}</div>
        )}
      </div>
    </div>
  );
}; 